'use client';

import CalculatorBase from '@/components/calculator/CalculatorBase';
import HeadlineField from '@/components/customFields/HeadlineField';
import { HeadlineTag } from '@/components/customFields/types';
import { RichText } from '@/components/richText/RichText';
import { shouldShowCalculatorStoryFooter } from '@/helper/calculatorFooter';
import { ProductCategory } from '@/helper/enums';
import classes from '@/storyblok/calculator/Calculators.module.scss';
import type { GlobalHtntCalculatorStoryblok } from '@/types/component-types-sb';
import { storyblokEditable } from '@storyblok/react/rsc';

const CalculatorHtNtProxy: React.FC<{
  blok: GlobalHtntCalculatorStoryblok;
  hideTitle?: boolean;
  hideFooter?: boolean;
  tag?: HeadlineTag;
  calculatorStoryId?: string;
}> = ({ blok, hideTitle = false, hideFooter = false, tag = HeadlineTag.H2, calculatorStoryId }) => {
  return (
    <div {...storyblokEditable(blok)}>
      {blok.title && !hideTitle && (
        <HeadlineField className={classes.calculatorMainTitle} tag={tag} style={HeadlineTag.H4}>
          {blok.title}
        </HeadlineField>
      )}
      <CalculatorBase
        type={ProductCategory.Electricity}
        button={blok.button}
        spc={blok.spcConfig && blok.spcConfig[0]}
        heatflow={true}
        calculatorStoryId={calculatorStoryId}
      />
      {shouldShowCalculatorStoryFooter(blok.text, { hideFooter, hideFooterText: blok.hide_footer_text }) && (
        <RichText className={classes.calculatorFooter} text={blok.text} />
      )}
    </div>
  );
};

export default CalculatorHtNtProxy;
